var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('van-icon',{staticClass:"icon",attrs:{"name":"search"}}),_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }